module.exports = import("@fortawesome/pro-regular-svg-icons/faTimes");;